<template>
  <v-tooltip
    v-if="!disabled"
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <avs-button
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
        fab
        iconI="mdi-pencil"
        icon
        label
        small
        color="secondary"
      />
    </template>
    <span>{{ spantext }}</span>
  </v-tooltip>
  <avs-button
    v-else
    v-bind="$attrs"
    v-on="$listeners"
    icon
    iconI="mdi-pencil-off"
    label
    fab
    small
    disabled
  />
</template>

<script>
export default {
  name: "EditButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    spantext: {
      type: String
    }
  }
}
</script>
